import { useState } from 'react'
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'
import { useCart } from '../../lib/cart'

// Shopper chrome: a standard e-commerce toolbar (brand, primary nav,
// search, basket, account) above the routed page. Distinct from the
// seller studio NavBar.
export default function ShopLayout() {
  const { user, clear } = useAuth()
  const { count } = useCart()
  const navigate = useNavigate()
  const location = useLocation()
  const [q, setQ] = useState('')

  function search(e: React.FormEvent) {
    e.preventDefault()
    navigate(q.trim() ? `/shop?q=${encodeURIComponent(q.trim())}` : '/shop')
  }

  return (
    <div className="shop">
      <header className="shop-header">
        <div className="shop-header-inner">
          <Link to="/shop" className="shop-brand">TEMPEST</Link>

          <nav className="shop-nav">
            <NavLink to="/shop" className={({ isActive }) => (isActive ? 'is-active' : '')} end>Home</NavLink>
            <a href="#live">Live</a>
            <a href="#brands">Brands</a>
            <a href="#malls">Malls</a>
          </nav>

          <form className="shop-search" onSubmit={search} role="search">
            <input
              type="search"
              placeholder="Search products, brands, malls…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              aria-label="Search"
            />
          </form>

          <div className="shop-header-actions">
            <Link to="/cart" className="shop-cart-link" data-testid="cart-link" aria-label="Basket">
              🛍
              {count > 0 && <span className="shop-cart-badge" data-testid="cart-count">{count}</span>}
            </Link>
            {user ? (
              <div className="shop-account-wrap">
                <span className="shop-account-name" data-testid="shop-account">
                  {(user.fullName || user.email).split(' ')[0]}
                  <span className="shop-role-pill">{user.role}</span>
                </span>
                <button className="btn-link" onClick={() => { clear(); navigate('/shop') }}>Sign out</button>
              </div>
            ) : (
              <Link to="/login" state={{ from: location }} className="btn-primary shop-signin-btn" data-testid="shop-signin">
                Sign in
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className="shop-main">
        <Outlet />
      </main>

      <footer className="shop-footer">
        <span>TEMPEST — livestream commerce, multi-mall.</span>
        <span className="muted">Demo storefront</span>
      </footer>
    </div>
  )
}
